import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const UserResidentialAddress = ({ _user }) => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.user);

  const [user, setUser] = useState(
    _user || location.state?.user || loggedInUser
  );

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      <Card>
        <CardHeader
          title={
            <Typography variant="subtitle1">
              Member Residential Address
            </Typography>
          }
          // action={
          //   <IconButton
          //     onClick={() => {
          //       openDialog("", "");
          //     }}
          //   >
          //     <EditOutlinedIcon />
          //   </IconButton>
          // }
        />
        <Divider sx={{ my: 1 }} />

        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Typography variant="caption" display="block">
                County
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {user.county || "N/A"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Typography variant="caption" display="block">
                Sub-County
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {user?.subcounty ?? "N/A"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Typography variant="caption" display="block">
                Ward
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {user.ward || "N/A"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Typography variant="caption" display="block">
                Village
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {user.village || "N/A"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Typography variant="caption" display="block">
                Residential address
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {user.residential_address || "N/A"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Typography variant="caption" display="block">
                Postal address
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {user.postal_address || "N/A"}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default UserResidentialAddress;
